import { Command } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { Output } from '../../output.js';
import { addGridOption, gridSlug, type GridOpts } from '../../grid-opt.js';

interface ListOpts extends GridOpts { json?: boolean; }

export async function runSpaceList(opts: ListOpts, client?: IV2Client): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false });
  const c = client ?? await getV2Client(gridSlug(opts));
  const { spaces } = await c.get<{ spaces: Array<{ slug: string; name: string; is_default: boolean; member_count: number }> }>('/api/v2/spaces');
  out.json(() => spaces);
  out.human(() => {
    if (spaces.length === 0) return 'No spaces.';
    const lines = ['Spaces in active grid:'];
    for (const s of spaces) {
      const badge = s.is_default ? ' (default)' : '';
      lines.push(`  - ${s.slug}${badge} — ${s.member_count} member${s.member_count === 1 ? '' : 's'}`);
    }
    return lines.join('\n');
  });
}

export const spaceListCommand = new Command('list')
  .description('List spaces in the active grid')
  .option('--json', 'JSON output');
addGridOption(spaceListCommand, 'Override active grid');
spaceListCommand
  .action(async (opts: ListOpts) => {
    try { await runSpaceList(opts); }
    catch (err) { await handleV2Error(err, { json: !!opts.json }); }
  });
